import { NavLink, useLocation } from 'react-router-dom';
import { useT } from '@/i18n/LocaleProvider';
import { BoardIcon, BookmarkIcon } from '@/components/icons/NavIcons';
import { cx } from '@/lib/cx';
import styles from './BottomNav.module.css';

/** Мобильная нижняя навигация 64px: Catalog / Saved / Canvases (прототип AppV2). */
export function BottomNav() {
  const t = useT();
  const { pathname } = useLocation();
  const isCanvases = pathname.startsWith('/canvases');
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    cx(styles.link, isActive && styles.active);

  return (
    <nav className={styles.nav} aria-label={t('nav.primary')}>
      <NavLink to="/" end className={linkClass}>
        <svg
          className={styles.icon}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <rect x="3.5" y="3.5" width="7" height="7" rx="1.5" />
          <rect x="13.5" y="3.5" width="7" height="7" rx="1.5" />
          <rect x="3.5" y="13.5" width="7" height="7" rx="1.5" />
          <rect x="13.5" y="13.5" width="7" height="7" rx="1.5" />
        </svg>
        {t('nav.catalog')}
      </NavLink>
      <NavLink to="/saved" className={linkClass} data-tour="nav-saved">
        <BookmarkIcon className={styles.icon} />
        {t('nav.saved')}
      </NavLink>
      <NavLink to="/canvases" className={() => cx(styles.link, isCanvases && styles.active)}>
        <BoardIcon className={styles.icon} />
        {t('nav.canvases')}
      </NavLink>
    </nav>
  );
}
